import React from "react";
import './Aboutstyle.css';

export default function About()
{
  return(
    <div className="about" id="About">
    <section className="aboutsec" id="About">
        <header><h1>About Us</h1></header>
        <div className="content">
          <div className="imgBox">
            <img src="./logo.png" />
          </div>
          <div className="textBox">
            <h2>TEA TALK POINT</h2><br />
            <p>Serving customer all over India. Our company is the fastest growing startup in India. In less than 3 years we have over 300 outlets all over India.
            We started this company in year 2022, with a small shop in Udaipur with a team of 2 members, now our team is growing rapidly and also our products is being loved by our fellow citizens.<br/> We want to thank the people of our country for showing immense love to our brand.</p> 
        </div>
        </div>
      </section>
      </div>

  );
}
